export default __webpack_public_path__ + "static/media/dumas-logo.015b372b.png";